module.exports = __webpack_public_path__ + "static/img/fish2.540943e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish2.png
// module id = 7Z8D
// module chunks = 0